const EmptyDot = props => (
  <svg
    width={21}
    height={21}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={10.5} cy={10.5} r={10.5} fill="white" />
    <circle cx={10.5} cy={10.5} r={8} fill="white" stroke="#CACFD6" />
  </svg>
)

export default EmptyDot
